module.exports = __webpack_public_path__ + "media/images/close_icon-c22ac89171798d5ad137cc047444ca5b.svg";